(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["butterfly-article-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-ll-guide]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      const body = dialog.querySelector('[data-guide-body]');
      const close = dialog.querySelector('[data-guide-close]');
      const triggers = root.querySelectorAll('[data-guide-open]');
      let opener;
      let requestedTarget;
      let navigationVersion = 0;
      let loaded = false;
      let loading;
      let previousOverflow;
      let previousPadding;
      let backdropPointerDown = false;
      const restore = () => {
        if (dialog.open) return;
        navigationVersion += 1;
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPadding;
        if (opener?.isConnected) opener.focus({preventScroll:true});
      };
      const loadArticle = async () => {
        if (loaded) return true;
        if (loading) return loading;
        body.setAttribute('aria-busy','true');
        body.replaceChildren();
        const status = document.createElement('p');
        status.className = 'll-guide-dialog__status';
        status.setAttribute('role','status');
        status.textContent = root.dataset.loading;
        body.append(status);
        loading = (async () => {
          try {
            const response = await fetch(root.dataset.articleUrl,{credentials:'same-origin'});
            if (!response.ok) throw new Error('Guide request failed');
            const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
            const article = parsed.querySelector('article.ll-article');
            if (!article) throw new Error('Guide content missing');
            article.querySelectorAll('[src],[href]').forEach(el => {
              for (const attr of ['src','href']) {
                const value = el.getAttribute(attr);
                if (value && !value.startsWith('#') && !value.startsWith('data:')) {
                  el.setAttribute(attr,new URL(value,response.url).href);
                }
              }
            });
            article.querySelectorAll('script').forEach(el=>el.remove());
            const styles = Array.from(parsed.querySelectorAll('style')).filter(el=>el.textContent.includes('.ll-article'));
            body.replaceChildren(...styles,article);
            loaded = true;
            return true;
          } catch {
            status.textContent = root.dataset.error;
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.textContent = root.dataset.retry;
            retry.addEventListener('click',openRequestedSection);
            status.append(retry);
            return false;
          } finally {
            body.setAttribute('aria-busy','false');
            loading = null;
          }
        })();
        return loading;
      };
      const scrollToSection = targetId => {
        const target = body.querySelector(`[id="${CSS.escape(targetId || '')}"]`);
        if (!target) return false;
        const nav = body.querySelector('.ll-nav');
        const navHeight = nav ? nav.getBoundingClientRect().height : 0;
        const top = body.scrollTop + target.getBoundingClientRect().top - body.getBoundingClientRect().top - body.clientTop - navHeight - 12;
        body.scrollTo({top:Math.max(0,top),behavior:'instant'});
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
        return true;
      };
      const openRequestedSection = async () => {
        const version = ++navigationVersion;
        const targetId = requestedTarget;
        if (!await loadArticle()) return;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (version !== navigationVersion || !dialog.open || !root.isConnected) return;
          scrollToSection(targetId);
        }));
      };
      triggers.forEach(trigger => trigger.addEventListener('click',() => {
        if (dialog.open) return;
        opener = trigger;
        requestedTarget = trigger.dataset.guideTarget;
        previousOverflow = document.body.style.overflow;
        previousPadding = document.body.style.paddingRight;
        const gap = window.innerWidth-document.documentElement.clientWidth;
        if (gap>0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight)+gap}px`;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        body.scrollTop = 0;
        close.focus({preventScroll:true});
        openRequestedSection();
      }));
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',restore);
      dialog.addEventListener('pointerdown',event=>{backdropPointerDown=event.target===dialog;});
      dialog.addEventListener('click',event=>{if(backdropPointerDown&&event.target===dialog)dialog.close();backdropPointerDown=false;});
      body.addEventListener('click',event=>{
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = body.querySelector(`[id="${CSS.escape(link.hash.slice(1))}"]`);
        if (!target) return;
        event.preventDefault();
        navigationVersion += 1;
        scrollToSection(target.id);
      });
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target.contains(root)&&dialog.open)dialog.close();
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["duo-article-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-ll-duo-guide]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      const body = dialog.querySelector('[data-guide-body]');
      const close = dialog.querySelector('[data-guide-close]');
      const triggers = root.querySelectorAll('[data-guide-open]');
      let opener;
      let requestedTarget;
      let navigationVersion = 0;
      let loaded = false;
      let loading;
      let previousOverflow;
      let previousPadding;
      let backdropPointerDown = false;
      const restore = () => {
        if (dialog.open) return;
        navigationVersion += 1;
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPadding;
        if (opener?.isConnected) opener.focus({preventScroll:true});
      };
      const loadArticle = async () => {
        if (loaded) return true;
        if (loading) return loading;
        body.setAttribute('aria-busy','true');
        body.replaceChildren();
        const status = document.createElement('p');
        status.className = 'll-duo-guide-dialog__status';
        status.setAttribute('role','status');
        status.textContent = root.dataset.loading;
        body.append(status);
        loading = (async () => {
          try {
            const response = await fetch(root.dataset.articleUrl,{credentials:'same-origin'});
            if (!response.ok) throw new Error('Guide request failed');
            const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
            const article = parsed.querySelector('article.ll-duo-article');
            if (!article) throw new Error('Guide content missing');
            article.querySelectorAll('[src],[href]').forEach(el => {
              for (const attr of ['src','href']) {
                const value = el.getAttribute(attr);
                if (value && !value.startsWith('#') && !value.startsWith('data:')) {
                  el.setAttribute(attr,new URL(value,response.url).href);
                }
              }
            });
            article.querySelectorAll('script').forEach(el=>el.remove());
            const styles = Array.from(parsed.querySelectorAll('style')).filter(el=>el.textContent.includes('.ll-duo-article'));
            body.replaceChildren(...styles,article);
            loaded = true;
            return true;
          } catch {
            status.textContent = root.dataset.error;
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.textContent = root.dataset.retry;
            retry.addEventListener('click',openRequestedSection);
            status.append(retry);
            return false;
          } finally {
            body.setAttribute('aria-busy','false');
            loading = null;
          }
        })();
        return loading;
      };
      const scrollToSection = targetId => {
        const target = body.querySelector(`[id="${CSS.escape(targetId || '')}"]`);
        if (!target) return false;
        const nav = body.querySelector('.ll-nav');
        const navHeight = nav ? nav.getBoundingClientRect().height : 0;
        const top = body.scrollTop + target.getBoundingClientRect().top - body.getBoundingClientRect().top - body.clientTop - navHeight - 12;
        body.scrollTo({top:Math.max(0,top),behavior:'instant'});
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
        return true;
      };
      const openRequestedSection = async () => {
        const version = ++navigationVersion;
        const targetId = requestedTarget;
        if (!await loadArticle()) return;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (version !== navigationVersion || !dialog.open || !root.isConnected) return;
          scrollToSection(targetId);
        }));
      };
      triggers.forEach(trigger => trigger.addEventListener('click',() => {
        if (dialog.open) return;
        opener = trigger;
        requestedTarget = trigger.dataset.guideTarget;
        previousOverflow = document.body.style.overflow;
        previousPadding = document.body.style.paddingRight;
        const gap = window.innerWidth-document.documentElement.clientWidth;
        if (gap>0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight)+gap}px`;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        body.scrollTop = 0;
        close.focus({preventScroll:true});
        openRequestedSection();
      }));
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',restore);
      dialog.addEventListener('pointerdown',event=>{backdropPointerDown=event.target===dialog;});
      dialog.addEventListener('click',event=>{if(backdropPointerDown&&event.target===dialog)dialog.close();backdropPointerDown=false;});
      body.addEventListener('click',event=>{
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = body.querySelector(`[id="${CSS.escape(link.hash.slice(1))}"]`);
        if (!target) return;
        event.preventDefault();
        navigationVersion += 1;
        scrollToSection(target.id);
      });
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target.contains(root)&&dialog.open)dialog.close();
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
